import React, { Component } from 'react'
import { Container, Row, Col, Card, CardBody } from 'reactstrap'
import RentalsList from './RentalsList'
import { debounce } from 'lodash'
import "./Rentals.css"
import RentalsListHeader from "./RentalsListHeader"
import ListingTabs from '../../Material/ListingTabs'
import ReportsPanel from '../../Reports/ReportsPanel'
import { buildPresets } from '../../Filters/presetFilters'

import withApolloClient from '../../withApolloClient'

// The page's one default filter, expressed as an Advanced Filters preset --
// the same FilterInput shape the query already sends for user filters, so the
// popover, the chips and the query all read one source of truth. Editable:
// users could change the Rental Stage before, so they still can.
// "10" is the raw model value -- NOT the graphene enum name "A_10".
const RENTAL_STAGE_PRESET = [
    { fieldName: "stage", filterType: "equal", filterValues: "10", editable: true },
]

// No URL hash routing here (unlike Incidents/CarReturn/Insurance) -- this page
// never had tabs before, so there is nothing to preserve deep links for. Local
// state is enough: switching to Reports and back is not something a link needs
// to reproduce.
const RENTALS_LISTING_TABS = [
    { id: "#all", name: "All Rentals" },
    { id: "#reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true },
]

class RentalsListContainer extends Component {
    constructor(props) {
        super(props)
        // presets and defaultPresets start out equal -- setPresets only ever
        // updates presets, so defaultPresets stays the declared set and is
        // what Reset returns to.
        const initialPresets = buildPresets(RENTAL_STAGE_PRESET)
        this.state = {
            filterValues: {
                orderBy: ["-start_date", "-driver__in_office"],
            },
            presets: initialPresets,
            defaultPresets: initialPresets,
            selectedDrivers: [],
            activeTab: RENTALS_LISTING_TABS[0].id,
        }
    }
    changeTab = (tabId) => this.setState({ activeTab: tabId })
    setPresets = (presets) => this.setState({ presets })
    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (value === "null") {
            value = null
        }
        if (value === "false") {
            value = false
        } else {
            value = true
        }
        this.setState({ [name]: value })
    };
    updateSelection = (selection) => {
        if (Array.isArray(selection)) {
            this.setState({ selectedDrivers: selection })
        } else {
            if (this.state.selectedDrivers.includes(selection))
                this.setState({ selectedDrivers: this.state.selectedDrivers.filter(item => item != selection) })
            else
                this.setState({ selectedDrivers: [...this.state.selectedDrivers, selection] })
        }
    }
    updateSearchTerm = debounce((searchTerm) => {
        this.setState({ searchTerm: searchTerm })
    }, 500)

    updateOrder = (string) => {
        let order = [...this.state.filterValues.orderBy]
        if (!order.includes(string) && !order.includes("-" + string)) {
            order = [order.find(item => item.includes("-driver__in_office")), string]
        } else {
            let index = order.indexOf(string)
            if (order.indexOf(string) > -1) {
                order[index] = "-" + string
            } else {
                index = order.indexOf("-" + string)
                index > -1 && (order[index] = string)
            }
        }
        this.setState({ filterValues: { ...this.state.filterValues, orderBy: order } })
    }

    render() {
        return (
            <Container fluid className="rental-list-container">
                <ListingTabs
                    tabs={RENTALS_LISTING_TABS}
                    activeTab={this.state.activeTab}
                    onChange={this.changeTab}
                />
                {this.state.activeTab !== "#reports" && <RentalsListHeader
                    activeTab="All Rentals"
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    presets={this.state.presets}
                    setPresets={this.setPresets}
                    defaultPresets={this.state.defaultPresets}
                    selectedDrivers={this.state.selectedDrivers} history={this.props.navigate} location={this.props.location}
                    resetSelectedDrivers={() => this.setState({ selectedDrivers: [] })}
                />}
                <Row>
                    <Col>
                        {this.state.activeTab === "#reports" ?
                            <ReportsPanel reportId="agreements" />
                            :
                            <RentalsList
                                updateOrder={this.updateOrder}
                                orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                presets={this.state.presets}
                                selectedDrivers={this.state.selectedDrivers}
                                updateDriversSelection={this.updateSelection}
                            />}
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default withApolloClient(RentalsListContainer)

